/**
 * arco Form 实例的最小子集：只需要 validate()。
 * 不直接依赖 @arco-design/web-react/Form 的具体类型导出，
 * 避免不同版本下路径/类型差异。
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

const ok = values => ({
  ok: true,
  values
});
const err = () => ({
  ok: false
});

/**
 * 把单个 Form 的 validate() 包成 { ok, values }，避免 try/catch 噪声。
 */
export function validateForm(form) {
  return form.validate().then(v => ok(v))
  // 校验失败是正常流程（Arco 会 reject 一个 ValidateError），这里不打印
  .catch(() => err());
}

/**
 * 并行校验多个 Form，任一失败整体失败。
 *   ok=true 时，values 按传入顺序排列；
 *   ok=false 时 values 为空数组（避免不必要的错误对象构建）。
 */
export async function validateForms(forms) {
  const results = await Promise.all(forms.map(f => f ? validateForm(f) : ok({})));
  const values = [];
  for (const r of results) {
    if (!r.ok) return {
      ok: false
    };
    values.push(r.values);
  }
  return {
    ok: true,
    values
  };
}